import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// Lazy load all page components for code splitting
const GinextLanding = lazy(() => import('./pages/GinextLanding').then(m => ({
  default: m.GinextLanding
})));
const GinextBodyReliefPage = lazy(() => import('./pages/GinextBodyReliefPage').then(m => ({
  default: m.GinextBodyReliefPage
})));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage').then(m => ({
  default: m.CheckoutPage
})));
const AdvertorialPage = lazy(() => import('./pages/AdvertorialPage').then(m => ({
  default: m.AdvertorialPage
})));
const LegSwellingAdvertorial = lazy(() => import('./pages/LegSwellingAdvertorial').then(m => ({
  default: m.LegSwellingAdvertorial
})));
const OptionsPage = lazy(() => import('./pages/OptionsPage').then(m => ({
  default: m.OptionsPage
})));
const NeckShouldersPage = lazy(() => import('./pages/NeckShouldersPage').then(m => ({
  default: m.NeckShouldersPage
})));
const LowerUpperBackPage = lazy(() => import('./pages/LowerUpperBackPage').then(m => ({
  default: m.LowerUpperBackPage
})));
const KneeJointsPage = lazy(() => import('./pages/KneeJointsPage').then(m => ({
  default: m.KneeJointsPage
})));
const FeetAnkleAdvertorialPage = lazy(() => import('./pages/FeetAnkleAdvertorialPage').then(m => ({
  default: m.FeetAnkleAdvertorialPage
})));
const SwollenLegsAdvertorialPage = lazy(() => import('./pages/SwollenLegsAdvertorialPage').then(m => ({
  default: m.SwollenLegsAdvertorialPage
})));
const NeckShouldersAdvertorialPage = lazy(() => import('./pages/NeckShouldersAdvertorialPage').then(m => ({
  default: m.NeckShouldersAdvertorialPage
})));
const UpperLowerBackAdvertorialPage = lazy(() => import('./pages/UpperLowerBackAdvertorialPage').then(m => ({
  default: m.UpperLowerBackAdvertorialPage
})));
const KneeJointsAdvertorialPage = lazy(() => import('./pages/KneeJointsAdvertorialPage').then(m => ({
  default: m.KneeJointsAdvertorialPage
})));
const HandsWristsPage = lazy(() => import('./pages/HandsWristsPage').then(m => ({
  default: m.HandsWristsPage
})));
const HandsWristsAdvertorialPage = lazy(() => import('./pages/HandsWristsAdvertorialPage').then(m => ({
  default: m.HandsWristsAdvertorialPage
})));
const SwollenLegsPage = lazy(() => import('./pages/SwollenLegsPage').then(m => ({
  default: m.SwollenLegsPage
})));
const HipsGlutesPage = lazy(() => import('./pages/HipsGlutesPage').then(m => ({
  default: m.HipsGlutesPage
})));
const FeetAnklesLandingPage = lazy(() => import('./pages/FeetAnklesLandingPage').then(m => ({
  default: m.FeetAnklesLandingPage
})));
const HipsGlutesAdvertorialPage = lazy(() => import('./pages/HipsGlutesAdvertorialPage').then(m => ({
  default: m.HipsGlutesAdvertorialPage
})));
const LymphedemaPage = lazy(() => import('./pages/LymphedemaPage').then(m => ({
  default: m.LymphedemaPage
})));
const DrSebiAdvertorialPage = lazy(() => import('./pages/DrSebiAdvertorialPage').then(m => ({
  default: m.DrSebiAdvertorialPage
})));
const DashboardPage = lazy(() => import('./pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
// Declare fbq as a global function
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Loading fallback component
function LoadingFallback() {
  return <div className="min-h-screen flex items-center justify-center bg-white" data-id="element-0">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-ginger" data-id="element-1"></div>
    </div>;
}
// ScrollToTop component - scrolls to top on route change + fires Meta Pixel events
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Fire Meta Pixel events on every route change
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        content_name: pathname
      });
    }
  }, [pathname]);
  return null;
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel - Simplified approach
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      // Load the pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize pixel
      window.fbq('init', '1194736672084815');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <Router data-id="element-2">
      <ScrollToTop data-id="element-3" />
      <Suspense fallback={<LoadingFallback data-id="element-5" />} data-id="element-4">
        <Routes data-id="element-6">
          <Route path="/" element={<OptionsPage data-id="element-8" />} data-id="element-7" />
          <Route path="/options" element={<OptionsPage data-id="element-10" />} data-id="element-9" />
          <Route path="/a" element={<AdvertorialPage data-id="element-12" />} data-id="element-11" />
          <Route path="/dr-sebi" element={<DrSebiAdvertorialPage data-id="element-14" />} data-id="element-13" />
          <Route path="/home" element={<GinextLanding data-id="element-16" />} data-id="element-15" />
          <Route path="/home-b" element={<GinextLanding data-id="element-18" />} data-id="element-17" />
          <Route path="/ginext" element={<GinextBodyReliefPage data-id="element-20" />} data-id="element-19" />
          <Route path="/feet&ankles" element={<FeetAnklesLandingPage data-id="element-22" />} data-id="element-21" />
          <Route path="/b" element={<LegSwellingAdvertorial data-id="element-24" />} data-id="element-23" />
          <Route path="/checkout" element={<CheckoutPage data-id="element-26" />} data-id="element-25" />
          <Route path="/ADVERT-FEET&ANKLE" element={<FeetAnkleAdvertorialPage data-id="element-28" />} data-id="element-27" />
          <Route path="/ADVERT-HANDS&WRIST" element={<HandsWristsAdvertorialPage data-id="element-30" />} data-id="element-29" />
          <Route path="/ADVERT-KNEES-JOINTS" element={<KneeJointsAdvertorialPage data-id="element-32" />} data-id="element-31" />
          <Route path="/ADVERT-SWOLLEN-LEGS" element={<SwollenLegsAdvertorialPage data-id="element-34" />} data-id="element-33" />
          <Route path="/ADVERT-NECK&SHOULDERS" element={<NeckShouldersAdvertorialPage data-id="element-36" />} data-id="element-35" />
          <Route path="/ADVERT-UPPER&LOWERBACK" element={<UpperLowerBackAdvertorialPage data-id="element-38" />} data-id="element-37" />
          <Route path="/ADVERT-HIPS&GLUTES" element={<HipsGlutesAdvertorialPage data-id="element-40" />} data-id="element-39" />
          <Route path="/NECK&SHOULDERS" element={<NeckShouldersPage data-id="element-42" />} data-id="element-41" />
          <Route path="/LOWER&UPPERBACK" element={<LowerUpperBackPage data-id="element-44" />} data-id="element-43" />
          <Route path="/KNEES&JOINTS" element={<KneeJointsPage data-id="element-46" />} data-id="element-45" />
          <Route path="/HANDS&WRISTS" element={<HandsWristsPage data-id="element-48" />} data-id="element-47" />
          <Route path="/SWOLLEN-LEGS" element={<SwollenLegsPage data-id="element-50" />} data-id="element-49" />
          <Route path="/HIPS&GLUTES" element={<HipsGlutesPage data-id="element-52" />} data-id="element-51" />
          <Route path="/lymphedema" element={<LymphedemaPage data-id="element-54" />} data-id="element-53" />
          <Route path="/dash" element={<DashboardPage data-id="element-56" />} data-id="element-55" />
        </Routes>
      </Suspense>
    </Router>;
}